var youbora = require('youboralib')

youbora.Request.prototype.createXHR = function () {
  try {
    return new enyo.Ajax()
  } catch (err) {
    youbora.Log.error(err)
    return {}
  }
}

youbora.Request.prototype.getXHR = function () {
  return this.xhr.xhr
}

youbora.Request.prototype.on = function (event, callback, callbackParams) {
  try {
    if (typeof callback != "undefined" && typeof callback != "function") {
      youbora.Log.warn("Warning: Request '" + this.getUrl() + "' has a callback that is not a function.")
      return this
    }
    if (event == 'error') {
      this.hasError = true
      this.xhr.error(callback)
    } else {
      this.xhr.response(callback)
    }
  } catch (err) {
    youbora.Log.error(err)
  } finally {
    return this
  }
}

youbora.Request.prototype.send = function () {
  try {
    this.xhr.url = this.getUrl()
    this.xhr.handleAs = 'xml'
    this.xhr.method = this.options.method

    if (this.options.requestHeaders) {
      this.xhr.headers = this.options.requestHeaders
    }

    // Add retries system
    if (this.options.retryAfter > 0 && this.options.maxRetries > 0) {
      var genericError = function () {
        if (this.retries >= this.options.maxRetries) {
          youbora.Log.error('Aborting failed request "' + this.service + '". Max retries reached.')
        } else {
          youbora.Log.warn('YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + ' of ' +
            this.options.maxRetries + ' in ' + this.options.retryAfter + 'ms.')

          setTimeout(function () {
            this.retries += 1
            this.send()
          }.bind(this), this.options.retryAfter)
        }
      }
      if (this.retries === 0) {
        this.on(youbora.Request.Event.ERROR, genericError.bind(this))
      }
    }

    // Log XHR
    if (youbora.Log.logLevel <= youbora.Log.Level.VERBOSE) {
      youbora.Log.verbose('XHR Req: ' + this.getUrl())
    }

    // Register 'on every' listeners
    for (var event in youbora.Request._globalListeners) {
      youbora.Request._globalListeners[event].forEach(function (callback) {
        this.on(event, callback)
      }.bind(this))
    }

    // Send
    return this.xhr.go()
  } catch (err) {
    youbora.Log.error(err)
  }
}

youbora.ViewTransform.prototype._receiveData = function (req, e) {
  var msg = req.xhr.response
  this.setData(msg)
}
